<template>
	<div class="minHei">
		<ul style="width: 100%;background-color: #FFFFFF;">
			<!-- <tSearch></tSearch> -->
			<newTpSearch :hotState='false'></newTpSearch>
		</ul>
		<!-- <ul style="width: 100%;background-color: #FFFFFF;">
			<div class="main">
				<p @click="handleFindIndexEvent(item,index)" :key="index" 
				v-for="(item,index) in listArr" class="showHand">
					<img :src="item.find_img">
				</p>
			</div>
		</ul> -->
		
		<ul style="width: 100%;background-color: #FFFFFF;">
			<div class="main">
				<p @click="handleFindIndexEvent(item,index)" :key="index" 
				v-for="(item,index) in listArr" class="showHand">
					<img :src="item.find_img">
				</p>
			</div>
		</ul>
		
	</div>
</template>

<script>
	let _self;
	import newTpSearch from '../../components/newTpSearch.vue'
	import { fileUpload,appCUserFindById } from '@/api/comm.js'
	import { selectFindListBySearch,appCGoodsInfoByGoodsId } from "@/api/find.js"
	import tSearch from "@/components/tSearch.vue"
	export default {
		name: 'Find',
		components: {
			tSearch,
			newTpSearch
		},
		data() {
			return {
				pageInfo:{
					page:1,
					size:6
				},
				// 是有允许请求下一页==true有下一页
				findListIsNext:false,
				// 页面数据
				listArr:null,
				findimg: [
					// {
					// 	img: require("@/assets/img/delImg/f_1.png")
					// }
				],
				// 用户信息
				userInfo:null,
				
				jmsId:this.$store.getters.getJmsId,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			this.$EventBus.$emit('AppCloseNav', true);
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log("用户信息",_self.userInfo);
			if(_self.userInfo){
				// 有用户信息
				_self.handleUpdateUserInfo();
			}
			
			//获取发现列表信息
			_self.getFindList();
		},
		methods:{
			// 更新用户信息
			handleUpdateUserInfo(){
				appCUserFindById({
					userId:_self.userInfo.userId
				}).then(tes=>{
					if(tes.code==200){
						// 接口获取成功
						//定义本地存储的userInfo
						localStorage.setItem('userInfo',JSON.stringify(tes.data))
						// 传递给topBar==用户信息
						_self.$EventBus.$emit('userEditInfo',tes.data)
						// 定义当前用户信息
						_self.$set(_self,'userInfo',tes.data)
					}
				})
			},
			//获取发现列表信息
			getFindList(){
				selectFindListBySearch({
					..._self.pageInfo,
					searchFindName:''
				}).then(res=>{
					// console.log("发现页面列表查询",res);
					if(res.data&&res.code==200){
						// _self.findimg=res.data.list;
						
						// 判断有无数据
						if(res.data.list && res.data.list.length ){
							// 判断页数
							if(_self.pageInfo.page==1){
								_self.listArr=res.data.list;
							}else{
								_self.listArr=[..._self.listArr,...res.data.list];
							}
						}else if(_self.pageInfo.page==1){
							// 没有数据，请求第一页====定义空数组
							_self.listArr=[];
						}
						
						// 判断是否有下一页可以请求
						_self.findListIsNext=res.data.hasNextPage;
					}
				})
			},
			// 发现模块点击事件
			handleFindIndexEvent(item,index){
				// console.log('查看点击信息===',[item,index]);
				// 判断跳转方式
				if(item.goods_id){
					// 跳转到商品详情
					
					// 请求traderGoodsId
					appCGoodsInfoByGoodsId({
						goodsId:item.goods_id,
						traderId:_self.jmsId
					}).then(res=>{
						console.log('返回值===',res);
						if(res.code==200 && res.data && res.data.length){
							
							// 定义商品id
							// 编码encodeURIComponent() ||  解码decodeURIComponent()
							let pageVal=encodeURIComponent(JSON.stringify({shopId:res.data[0].tardergoodsId}));
							// 跳转到搜索页面并传递搜索信息
							_self.$router.push({path:'/ShopDetails',query:{id:pageVal}})
						}else{
							_self.$jgTips('加盟商未上架此商品。')
						}
					})
				}else{
					// 跳转分类列表
					// console.log('跳转分类');
					// 定义搜索页请求参数
					item.categoryId=item.category_id;
					item.categoryName=item.category_name;
					
					// decodeURIComponent
					// 编码encodeURIComponent()
					let pageVal=encodeURIComponent(JSON.stringify({pageType:2,pageVal:item}));
					// 页面跳转===》
					_self.$router.push({path:'/ShopList',query:{searchVal:pageVal}})
				}
			},
		},
		mounted() {
			// 滚动到头部
			window.scrollTo({
			    left: 0,
			    top: 0,
			});
			// 监听页面滑动
			window.onscroll = function(){
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
				// 获取当前页面名称
				let pageName=_self.$router.history.current.name;
				
				//滚动条到底部的条件：  滑动距离+滑块高度大于侧边滚动条长度***最新的滚动条长度不等于上回的高度***允许加载下一页
				if( pageName=='Find' && scrollTop+windowHeight==scrollHeight
				&& _self.findListIsNext){
					// console.log('滑倒底部开始请求');
					// 不允许请求下一页====防止频繁请求
					_self.findListIsNext=false;
					
					// 请求页码数+1
					_self.pageInfo.page++;
					// 数据请求
					_self.getFindList();
				}
			}
		}
	}
</script>

<style scoped>
	.minHei{
		min-height: 750px;
	}
	.main {
		margin: 0 auto;
		width: 1200px;
		display: flex;
		flex-direction: column;
		/* flex-flow: row wrap; */
		align-items: center;
		justify-content: center;
		/* justify-content: space-between; */
		background-color: #FFFFFF;
	}

	.main p {
		margin-bottom: 30px;
	}

	.main img {
		display: block;
		width: 585px;
		height: 340px;
	}
</style>
